import { HeroCarouselItemsContentProps } from '../hero-carousel'
import { getCustomStyles } from '../utils'

type Props = {
  textAlignment: CanvasTextAlign
  content: HeroCarouselItemsContentProps
}

export const Badge = (props: Props) => {
  const customStylesBadge = getCustomStyles(props.content?.badge?.styles)
  return props.content?.badge?.text ? (
    <div
      className="w-fit text-center py-1 px-6 mb-2 font-light text-[12px] rounded-t-lg rounded-br-lg"
      style={{
        ...customStylesBadge,
        marginInline: `${props.textAlignment === 'center' ? 'auto' : '0'}`,
      }}
    >
      {props?.content?.badge?.text}
    </div>
  ) : null
}
